import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/AuthContext';

export const GroupViewTest: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  console.log('🔍 GroupViewTest component rendered with id:', id);
  console.log('🔍 User:', user);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Group View Test</h1>
        <p className="text-gray-600 mb-4">Group ID: {id}</p>
        <p className="text-gray-600 mb-4">User: {user?.email || 'No user'}</p>
        <button
          onClick={() => navigate('/community')}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Back to Community
        </button>
      </div>
    </div>
  );
};
















